"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerClientPlugin = exports.markPluginFailed = exports.pluginRegistry = exports.createClientPluginRegistry = void 0;
const createClientPluginRegistry = () => {
    const plugins = [];
    const subscribers = new Set();
    let version = 0;
    return {
        register(plugin) {
            if (plugins.some((p) => p.id === plugin.id)) {
                throw new Error(`Client plugin "${plugin.id}" registered twice`);
            }
            plugins.push(plugin);
            version += 1;
            for (const fn of subscribers) {
                fn();
            }
        },
        list() {
            return plugins;
        },
        version() {
            return version;
        },
        onChange(fn) {
            subscribers.add(fn);
            return () => {
                subscribers.delete(fn);
            };
        },
    };
};
exports.createClientPluginRegistry = createClientPluginRegistry;
exports.pluginRegistry = (0, exports.createClientPluginRegistry)();
// Bundles whose load timed out or errored.
const failedPluginIds = new Set();
const markPluginFailed = (id) => {
    failedPluginIds.add(id);
};
exports.markPluginFailed = markPluginFailed;
const registerClientPlugin = (plugin) => {
    if (failedPluginIds.has(plugin.id)) {
        // eslint-disable-next-line no-console
        console.warn(`[plugins] ignoring late register() from "${plugin.id}" - its bundle already timed out or failed to load`);
        return;
    }
    exports.pluginRegistry.register(plugin);
    // eslint-disable-next-line no-console
    console.info(`[plugins] registered "${plugin.id}"`);
};
exports.registerClientPlugin = registerClientPlugin;
